







import Vue from 'vue';
/**
 * A v-toolbar replacement, which uses up less browser resources (each v-toolbar adds a window
 * scroll listener)
 */
export default Vue.extend({
  name: 'SToolbarLight',
  inheritAttrs: false,
  props: {
    color: {
      type: String,
      required: false,
      default: 'primary',
    },
    dense: {
      type: Boolean,
      required: false,
    },
    dark: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    className(): any[] {
      return [
        this.color,
        'toolbar-light',
        {
          'toolbar-light--dense': this.dense,
          'toolbar-light--light': !this.dark,
        },
      ];
    },
  },
});
